import Base from './Base';

class StripeInvoice extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'stripe/invoices';
        this.enableCoolDown = true;
    }
    
}

export default StripeInvoice;